import React from 'react';
import { WorkplaceTreeItem } from './UserSettingsWorkplace';
import styles from './UserSettingsWorkplaceItem.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import { WorkplaceType } from '../../../Manager/Enums/WorkplaceType.enum';

interface Props {
	item: WorkplaceTreeItem;
}

const UserSettingsWorkplaceItem: React.FC<Props> = ({ item }) => {
	let component;

	switch (item.type) {
		case WorkplaceType.MAIN:
			component = (
				<>
					<div className={styles.mainWorkplace}>
						<Text
							className={styles.subtitle}
							tx='registration.serviceProvider'
							firstUpper
							colon
						/>
						<div className={styles.name}>{item.name}</div>
						<div className={styles.address}>{item.address}</div>
					</div>
					<Text
						className={styles.title}
						tx='base.shared.workplace'
						colon
						firstUpper
					/>
				</>
			);
			break;
		case WorkplaceType.NORMAL:
			component = (
				<div className={styles.item}>
					<div className={styles.name}>{item.name}</div>
					<div className={styles.address}>{item.address}</div>
				</div>
			);
			break;
	}
	return (
		<>
			{component}
			{item.children?.map(child => (
				<UserSettingsWorkplaceItem item={child} />
			))}
		</>
	);
};

export default UserSettingsWorkplaceItem;
